// frontend/src/components/LazyLoginPage.js
//
// THE lazy Login page - the one object the /login route renders (appRoutes.js)
// and the one ProtectedRoute warms before it redirects a signed-out visitor
// there (backlog #158).
//
// WHY A MODULE OF ITS OWN. ProtectedRoute needs Login's preload, but it cannot
// import appRoutes.js: appRoutes imports ProtectedRoute, so that would be an
// import cycle (and would drag the whole route table into a component). Both
// therefore import this module, which imports neither of them. It has to be
// the SAME lazyWithPreload object on both sides, not two declarations of the
// same import(): lazyWithPreload renders a loaded module directly (no Suspense
// round trip) only for the object whose preload() loaded it, so a second copy
// would download the chunk and still suspend the route.
//
// Login is prerendered, so it must stay a lazyWithPreload (index.js awaits its
// preload before hydrating /login - .claude/rules/public-pages.md, "Prerender
// hydration"); routePreload.test.js fails if it does not.

import lazyWithPreload from "../utils/lazyWithPreload";

const LazyLoginPage = lazyWithPreload(() => import("../pages/Login"));

/**
 * Start (or join) the Login page's chunk download. Idempotent: every call
 * shares the one pending import, and once it has loaded the route renders the
 * page without suspending.
 *
 * @returns {Promise<unknown>} the import - it REJECTS when the chunk fails to
 *          load, so a caller that only warms the chunk must handle that.
 */
export function preloadLoginPage() {
  return LazyLoginPage.preload();
}

export default LazyLoginPage;
